import {useEffect, useState} from 'react';

// based of https://usehooks.com/useWindowSize/
export const usePageWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    function handleResize() {
        setWidth(
          window.innerWidth,
        );
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  });

  return width;
}

export const usePageSize = () => {
  const [size, setSize] = useState({width: window.innerWidth, height: window.innerHeight});
  useEffect(()=>{
    function handleResize() {
        setSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  });

  return size;
}